module.exports = __webpack_public_path__ + "static/img/project05.4806d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project05.png
// module id = BMSx
// module chunks = 1